import React, { useEffect, useState } from 'react';
import AuthorCard from '../Card/AuthorCard';
import HighlightOffIcon from '@material-ui/icons/HighlightOff';
import InfiniteScroll from 'react-infinite-scroller';
import { getUserName } from '../../services/common-query';
import AuthorCardskeleton from '../skeletons/authorcard';
import {
  collection,
  getDocs,
  query,
  where,
  limit,
  startAfter,
  orderBy,
} from 'firebase/firestore/lite';
import { firebaseFireStore } from '../../config/firebaseFirestore';

let backedAuthorArr = [];
let startAfterSnap = null;

function getThresholdDimensions() {
  const { innerWidth: width, innerHeight: height } = window;
  return width;
}

export default function CollectorsComponent() {
  const [searchFilter, setsearchFilter] = useState('');
  const [ratingFilter, setRatingFilter] = useState('sort');
  const [loadingSellers, setloadingSellers] = useState(false);
  const [sellerDataArr, setsellerDataArr] = useState([]);
  const [hasMore, sethasMore] = useState(true);
  const [threshold, setthreshold] = useState(1000);

  useEffect(() => {
    return () => {
      // Executed only when component unmounts,
      backedAuthorArr = [];
      startAfterSnap = null;
    };
  }, []);

  useEffect(() => {
    function handleResize() {
      let val = getThresholdDimensions();
      let hold = 1500;

      if (val < 768) {
        hold = 4000;
      } else if (val < 1280) {
        hold = 2500;
      }

      setthreshold(hold);
    }
    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const getTopSellers = async () => {
    if (!loadingSellers) {
      setloadingSellers(true);

      // let dataRef = fi/rebase
      //   ./)
      //   .collection("musicartSellers")
      //   .wh/ere("adminState", "==", "ACCEPT");
      // .orderBy("followers", "desc");
      let dataRef = startAfterSnap
        ? query(
            collection(firebaseFireStore, 'musicartSellers'),
            where('adminState', '==', 'ACCEPT'),
            where('isCollector', '==', true),
            orderBy('collectorJoiningDate', 'desc'),
            startAfter(startAfterSnap),
            limit(10),
          )
        : query(
            collection(firebaseFireStore, 'musicartSellers'),
            where('adminState', '==', 'ACCEPT'),
            where('isCollector', '==', true),
            orderBy('collectorJoiningDate', 'desc'),
            limit(10),
          );

      // if (startAfterSnap) {
      //   dataRef = dataRef.startAfter(startAfterSnap);
      // }

      dataRef = await getDocs(dataRef);

      if (dataRef.empty) {
        if (backedAuthorArr.length !== sellerDataArr.length) {
          let dataArr = [...backedAuthorArr];
          filterDataLocally(dataArr, false, false);
        }

        sethasMore(false);
        setloadingSellers(false);

        return;
      }

      let dataArr = [];
      dataRef.forEach(async (docu) => {
        dataArr.push({ ...docu.data(), id: docu.id });
        startAfterSnap = dataRef.docs[dataRef.docs.length - 1];
      });

      await Promise.all(
        dataArr.map(async (ele, index) => {
          let collectorUserName = 'unknown';
          if (ele.id) {
            collectorUserName = await getNameFromId(ele.id);
            dataArr[index].collectorUserName = collectorUserName;
          }
        }),
      );
      backedAuthorArr = backedAuthorArr.concat(dataArr);
      filterDataLocally(backedAuthorArr, false, false);

      setloadingSellers(false);
    }
  };

  const getNameFromId = async (id) => {
    let lname = await getUserName(id);

    if (lname) {
      return lname;
    } else {
      return 'unknown';
    }
  };

  const filterDataLocally = (nftdataArrParam, searchParam, ratingParam) => {
    let dataArr = [...(nftdataArrParam ? nftdataArrParam : backedAuthorArr)];

    //search
    let searchVal = searchParam ? searchParam : searchFilter;
    if (searchVal !== '' && searchVal !== -1) {
      dataArr = dataArr.filter((x) => {
        if (
          // (x.name && x.name.toLowerCase().includes(searchVal.toLowerCase())) ||
          (x.bio && x.bio.toLowerCase().includes(searchVal.toLowerCase())) ||
          (x.collectorUserName &&
            x.collectorUserName.toLowerCase().includes(searchVal.toLowerCase()))
        ) {
          return x;
        }
      });
    }

    let ratingVal = ratingParam ? ratingParam : ratingFilter;
    if (ratingVal && dataArr) {
      if (ratingVal === 'popularity') {
        dataArr.sort((a, b) => b.totalLikes - a.totalLikes);
      }
      if (ratingVal === 'Recently-Created') {
        dataArr.sort(
          (a, b) =>
            Number(b.collectorJoiningDate) - Number(a.collectorJoiningDate),
        );
      }
      if (ratingVal === 'Alphabetically') {
        dataArr.sort(function (a, b) {
          if (a.collectorUserName && b.collectorUserName) {
            if (
              a.collectorUserName.toLowerCase() <
              b.collectorUserName.toLowerCase()
            ) {
              return -1;
            }
            if (
              a.collectorUserName.toLowerCase() >
              b.collectorUserName.toLowerCase()
            ) {
              return 1;
            }
            return 0;
          }
        });
      }
      // if (ratingVal === "sort") {
      //   dataArr.sort(() => Math.random() - 0.5);
      // }
    }
    setsellerDataArr(dataArr);
  };

  return (
    <>
      <main className="main center_container">
        <div className="container">
          <div className="row row--grid">
            <div className="w-full">
              <ul className="breadcrumb">
                <li className="breadcrumb__item">
                  <a href="/">Home</a>
                </li>
                <li className="breadcrumb__item breadcrumb__item--active">
                  Collectors
                </li>
              </ul>
            </div>

            <div className="w-full">
              <div className="main__title main__title--page px-4">
                <h1>Collectors</h1>
              </div>
            </div>

            <div className="w-full">
              <div className="px-4">
                <div className="main__filter">
                  <form
                    onSubmit={(e) => {
                      e.preventDefault();
                      filterDataLocally(backedAuthorArr, null, false);
                    }}
                    className="main__filter-search main__filter_child"
                  >
                    <input
                      style={{ width: '100%' }}
                      type="text"
                      placeholder="Search for collectors"
                      value={searchFilter}
                      onChange={(e) => {
                        setsearchFilter(e.target.value);
                      }}
                      onKeyDown={(e) => {
                        if (e.key === 'Enter') {
                          filterDataLocally(
                            backedAuthorArr,
                            e.target.value,
                            false,
                          );
                        }
                      }}
                      required
                    />
                    <div
                      style={{
                        position: 'absolute',
                        top: 10,
                        right: 0,
                      }}
                    >
                      {searchFilter && searchFilter.length > 0 && (
                        <button
                          type="button"
                          style={{
                            right: 50,
                          }}
                          onClick={() => {
                            filterDataLocally(backedAuthorArr, -1, false);
                            setsearchFilter('');
                          }}
                        >
                          <HighlightOffIcon />
                        </button>
                      )}{' '}
                      <button type="submit">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 24 24"
                        >
                          <path d="M21.71,20.29,18,16.61A9,9,0,1,0,16.61,18l3.68,3.68a1,1,0,0,0,1.42,0A1,1,0,0,0,21.71,20.29ZM11,18a7,7,0,1,1,7-7A7,7,0,0,1,11,18Z" />
                        </svg>
                      </button>
                    </div>
                  </form>

                  <div className="main__filter_child main__filter-wrap">
                    <select
                      className="main__select"
                      name="status"
                      onChange={(event) => {
                        let ratingByVal = event.target.value;
                        setRatingFilter(ratingByVal);
                        filterDataLocally(null, null, event.target.value);
                      }}
                      value={ratingFilter}
                    >
                      <option
                        style={{ display: 'none' }}
                        value="sort"
                        selected
                        disabled
                      >
                        Sort by
                      </option>
                      <option value="popularity"> Popularity</option>
                      <option value="Alphabetically"> Alphabetically</option>
                      <option value="Recently-Created">
                        {' '}
                        Recently Created
                      </option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <InfiniteScroll
            loadMore={() => getTopSellers()}
            hasMore={hasMore}
            threshold={threshold}
          >
            <div className="row row--grid" key="1">
              {sellerDataArr.length === 0 && hasMore === false ? (
                !loadingSellers && (
                  <div className="no__result__alert">No result found</div>
                )
              ) : (
                <>
                  {sellerDataArr
                    .filter((x) => {
                      return x.thumbnailImage && x.photoUrl;
                    })
                    .map((ele, index) => {
                      return (
                        <div
                          className="turning-screens 2xl:w-2/12 xl:w-5/12 lg:w-3/12 md:w-4/12 py-2 w-full"
                          key={'sellerNft' + index}
                        >
                          <AuthorCard ele={ele} />
                        </div>
                      );
                    })}

                  {hasMore && (
                    <>
                      {Array(10)
                        .fill()
                        .map(() => (
                          <AuthorCardskeleton />
                        ))}
                    </>
                  )}
                </>
              )}
            </div>
          </InfiniteScroll>
        </div>
      </main>
    </>
  );
}
